export default __webpack_public_path__ + "static/media/im.91cbbba0.svg";